import { useQuery, useMutation } from "@tanstack/react-query"
import { fileApi } from "@/lib/api/fileApi"

export function useUploadFile() {
  return useMutation({
    mutationFn: ({
      file,
      onProgress,
    }: {
      file: File
      onProgress?: (progress: number) => void
    }) => fileApi.upload(file, onProgress),
  })
}

export function useImageUrl(imageId?: string) {
  return useQuery({
    queryKey: ["image-url", imageId],
    queryFn: () => fileApi.getFileUrl(imageId!),
    enabled: !!imageId,
    retry: false,
    refetchOnWindowFocus: false,
  })
}

export function useFileBlob(fileId?: string, enabled = true) {
  return useQuery({
    queryKey: ["file-blob", fileId],
    queryFn: () => fileApi.getFile(fileId!),
    enabled: enabled && !!fileId,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
